import NoDataIcon from 'Components/common/assets/svgIcons/NoDataIcon';
import BulletListItem from 'Components/company/components/BulletListItem';
import { PainPoint } from 'Types/CompaniesTypes';
import {
  primaryFont, primaryHeadingColor, wBold,
} from 'Utils/utilsStyle';
import React from 'react';
import styled from 'styled-components';

const SwotWrapper = styled.span<{ color: string, bgColor: string }>`
  background-color: ${(props) => props.bgColor};
  border-top: 1px solid ${(props) => props.color};
  border-right: 1px dashed ${(props) => props.color};
  text-align: start;
  .bullet-list-item {
    margin-bottom: 10px;
    .bulletItem {
      text-align: start;
    }
    &:last-child {
      margin-bottom: 2px;
    }
  }
  &:last-child {
    border-right: 1px solid ${(props) => props.color} !important;
  }
`;

const NoData = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  .title {
    color: ${primaryHeadingColor};
    text-align: center;
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: ${wBold};
    line-height: 18px;
    letter-spacing: -0.297px;
    margin-top: 16px;
  }
`;

type Props = {
  data: PainPoint[],
  color: string,
  expandSwot?: boolean,
} & typeof defaultProps;

const defaultProps = {
  data: [{ heading: '', description: '' }],
  color: '#424B50',
  expandSwot: false,
};

const SwotCompanyData = function SwotCompanyData(props: Props) {
  const {
    data, color, expandSwot,
  } = props;

  return (
    <SwotWrapper
      className="second-area table-item"
      color={color}
      bgColor="#F5FBFF"
    >
      {data?.length && data[0].heading !== '' ? data
        .slice(0, expandSwot ? 20 : 2).map((d) => (
          <BulletListItem
            color={color}
            listHeading={d.heading}
            listDescription={d.description}
            swatTabFlag={false}
            expandSwotFlag={expandSwot}
          />
        ))
        : (
          <NoData>
            <NoDataIcon />
            <span className="title">
              No data found
            </span>
          </NoData>
        )}

    </SwotWrapper>
  );
};
SwotCompanyData.defaultProps = SwotCompanyData;
export default SwotCompanyData;
